/* eslint-disable max-lines */
import { ProductInterface } from '../../client/redux/products/types';
import { DataLayerPlatform } from './dataLayerManager/serverDataLayerManager';
import { Currency, CommonEventOptions, DataLayerItem } from 'Common/appshell_types';

// Some of these events are not relevant to us yet, but are added
// because they are listed in Alice and can be easily missed later on
export const GENERIC_GA_EVENT = 'genericGaEvent';
export const PAGEVIEW_EVENT = 'bellaPageView';
export const ADD_TO_CART_EVENT = 'addToCart';
export const REMOVE_FROM_CART_EVENT = 'event-removeFromCart';
export const START_USER_SESSION = 'startUserSession';

// Listing Page product advanced ecommerce
export const EC_LP_PRODUCT_CLICK_EVENT = 'PLP-ProductLink-Click';
export const EC_LP_PRODUCT_IMPRESSION_EVENT = 'PLP-Products-Impression';

// Homepage advanced ecommerce
export const EC_HP_PRODUCT_IMPRESSION_EVENT = 'ProductImpression';

// Header advance ecommerce tracking
export const HEADER_BANNER_SHOW = 'header_banner_shown';

export enum ShopToClubEvent {
    OverlayShown = 'clubRegistrationOverlayEvent-OverlayShown',
    OverlayDismissed = 'clubRegistrationOverlayEvent-OverlayDismissed',
    RegistrationSuccessful = 'clubRegistrationOverlayEvent-Success',
    DoiOverlayShown = 'clubRegistrationOverlayEvent-DoiInformationShown',
    PrivacyPolicyAcceptance = 'clubRegistrationOverlayEvent-PrivacyPolicyAcceptance',
    ProductListingBannerImpression = 'shopToClubProductListingBannerEvent-Impression',
    ProductListingBannerClick = 'shopToClubProductListingBannerEvent-Click',
}

export enum LoginAndRegisterEvent {
    SuccessfulRegistration = 'registrationEvent-subscriptionSuccessful',
}

export const SEARCH_LOGS_CATEGORY = 'Search logs';
export const SEARCH_CATEGORY = 'Search';
export const E_COMMERCE_CATEGORY = 'Ecommerce';
export const USERS_CATEGORY = 'Users';
export const FILTERS_CATEGORY = 'Filters';
export const HEADER_CATEGORY = 'Header';
export const HEADER_BAR_BANNER = 'HeaderBarBanner';
export const HEADER_PROMO_BAR_CATEGORY = 'promotionHeaderBanner';
export const SHOP_TO_CLUB_CATEGORY = 'Shop2Club Registration Overlay';
export const PDP_CATEGORY = 'PDP';
export const PDP_VIDEO_CATEGORY = 'PDP_Video';
export const PLP_CATEGORY = 'PLP';
export const LOOKS_LISTING_PAGE = 'Looks Listing Page';
export const INFUSION_IMPRESSIONS = 'InfusionImpressions';
export const FABRIC_SAMPLE_CATEGORY = 'Fabric Sample';
export const LDP_CATEGORY = 'Looks Detail Page';
export const LOOKS_DETAIL_PAGE_TYPE = 'looksDetail';
export const LOOKS_LISTING_PAGE_TYPE = 'looksListing';
export const EXPERIMENT = 'Experiment';
export const THREE_D_IMAGE_CATEGORY = '3D Image on PDP';

export enum ProductList {
    products = 'plp_products',
    noResults = 'plp_no_results_products',
}

export enum TrackSearchLogsActions {
    SearchPerformed = 'Search performed',
    SearchBounced = 'Bounced search',
}

export enum TrackSearchActions {
    NoResultPage = 'No result page',
    SearchSuggestClickWithoutRedirect = 'Click on Suggest without Redirect',
    SearchRedirectWithSuggest = 'Redirect with Suggest',
    SearchRedirectWithoutSuggest = 'Redirect without Suggest',
}

export enum TrackECommerceActions {
    ProductClick = 'Click on Product',
    HeroProductClick = 'Hero product - click',
    PlpUrlSearchTerm = 'PLP-URL-SearchTerm',
    BackInStockReminderClick = 'BISR click',
}

export enum TrackUsersActions {
    PaginationClickPrev = 'Pagination - Click on Previous',
    PaginationClickNext = 'Pagination - Click on Next',
    CrossCatNavClick = 'Cross-category navigation - Click',
    CrossCatNavDeselect = 'Cross-category navigation - Label deselected',
    ContentInfusionNavigation = 'Content Infusion Navigation - Click',
    ContentInfusionNavigationImpression = 'Content Infusion Navigation - Impression',
}

export enum TrackFiltersActions {
    SortingClick = 'Sorting option - Click',
    SortingActivatedFav = 'Sorting activated - Favorite',
    SortingActivatedNew = 'Sorting activated - New',
    SortingActivatedPriceDesc = 'Sorting activated - Price descending',
    SortingActivatedPriceAsc = 'Sorting activated - Price ascending',
    MobileFilterClick = 'Mobile filters button - Click',
    FilterActivated = 'Filter - Activated',
    FilterClick = 'Filter - Click',
    FilterReset = 'Reset filters - Click',
    FilterRemoved = 'Filter - Removed',
}

export enum TrackPDPActions {
    BrandClick = 'Click on the brand',
    AddToCart = 'Add to Cart',
    PdpZoomEnabled = 'PDP_enable_zoom',
    RatingAndReviewsLoad = 'Ratings and Reviews bar_Load',
    RatingAndReviewsClick = 'Ratings and Reviews bar_Click',
    QuantitySelectorClick = 'Quantity Selector - Click',
    SizeSelectorClick = 'Size selector - Click',
    RelatedSlidersView = 'Related Slider View',
    RelatedSliderProductClick = 'Related Slider_Product Click',
    ImageImpressions = 'Image Impression',
    QuantitySelector = 'QuantitySelector',
    ThreeDImageButtonPressed = '3D Image - Button Pressed',
    ThreeDImageModelDownloaded = '3D Image - Model Downloaded',
    ThreeDImageModelInteraction = '3D Image - Model interaction',
    ThreeDImageDuration = '3D Session Length - Item downloaded until Scene closed',
    ThreeDImageCTAImpression = '3D Image - CTA button impression',
    AssemblyServiceImpression = 'Assembly Service - Impression',
    AssemblyServiceSelectClick = 'Assembly Service - Select Clicks',
    AssemblyServiceDeselectClick = 'Assembly Service - Deselect Clicks',
    AssemblyServiceInfoIconClick = 'Assembly Service Information Icon - Clicks',
}

export enum TrackLooksActions {
    LLPCategory = 'Category - Click',
    LLPLook = 'Look - Click',
    LLPImpression = 'Looks - Impression',
    LLPCategoryBubble = 'Category Bubble - Click',
    LLPDescriptionReadMore = 'Description Text - see more button click',
    LLPFilterClick = 'Filter - Click',
    LLPFilterOverlayImpression = 'Filter Overlay - Impressions',
    LLPFilterActivated = 'Filter - Activated',
    LLPBackButtonClick = 'Back button - Click',
    LLPNoLooksFound = 'No looks result page - Impression',
    LLPSeeAllLooksButtonImpression = 'See all looks button - Impression',
    LLPSeeAllLooksButtonClick = 'See all looks button - Click',
    LLPAddLookWishlist = 'Add Look to wishlist',
    LLPRemoveLookWishlist = 'Remove Look from wishlist',
    LLPPromotionalElementImpression = 'Promo - Impression',
    LLPPromotionalElementClick = 'Promo - Click',
    // LooksDetailPage trackings
    LDPProductClick = 'Product - Click',
    LDPProductOverlayClick = 'Product Overlay - Click',
    LDPSliderClick = 'Looks slider - Click',
    LDPCartButtonClick = 'Cart Button - Click',
    LDPHotSpotClick = 'Hotspot - Click',
    LDPImageClick = 'Image - Click',
    LDPPrevLookClick = 'Previous Look - Click',
    LDPNextLookClick = 'Next Look - Click',
    LDPAddLookWishlist = 'Add Look to wishlist',
    LDPRemoveLookWishlist = 'Remove Look from wishlist',
    // Promo Tracking
    LDPPromoClick = 'Promotional infusion',
}

export enum TrackFabricSample {
    OpenOverlay = 'Click to order',
    SubmitOrder = 'Submit order',
}

export enum TrackPDPVideoActions {
    VideoLoad = 'PDP_Video_Load',
    VideoPlay = 'PDP_Video_Play',
    VideoPlayTime = 'PDP_Video_Playtime_duration',
}

export enum TrackPDPLooksInfusionActions {
    LookInfusionClick = 'Look infusion - Clicks',
    LookSliderClick = 'Look slider - Clicks',
    LookInfusionImpression = 'Look infusion - Impression',
    LookSliderImpression = 'Look slider - Impression',
    LookInfusionABTestExperiment = 'p100PdpLooksInfusion',
}

export enum TrackHeaderActions {
    HeaderCategoriesClick = 'Header Categories - Click',
    HeaderInteriorDesignClick = 'Header Interior Design - Click',
    HeaderShopTheLookClick = 'Header Shop the Look - Click',
    HeaderWishlistClick = 'Header Wishlist - Click',
    HeaderCartClick = 'Header Cart - Click',
    HeaderMyAccountClick = 'Header My Account - Click',
    HeaderLogoClick = 'Header Logo - Click',
    HeaderClubLinkClick = 'Club tab click',
    HeaderClubLinkClickFromMenu = 'Shop-Club tab click - Menu',
    HeaderShopLinkClickFromMenu = 'Shop-Shop tab click - Menu',
    HeaderSearchIconClick = 'Header Search Icon - click',
    HeaderNavBarCategories = 'Navigational bar Categories - Click',
    HeaderNavBarLooks = 'Navigational bar Shop the look - Click',
    HeaderNavBarWestwingCollection = 'Navigational bar Westwing Collection - Click',
    HeaderNavBarInteriorDesign = 'Navigational bar IDS - Click',
    HeaderHomeClick = 'Header Home icon - Click',
    HeaderMoodboardIconClick = 'Header Moodboard Icon - Click',
    HeaderInteriorDesignIconClick = 'Header Interior Design Icon - Click',
    HeaderFirstLevelNavClick = 'Header first level navigation desktop - Click',
    HeaderShopTabClick = 'Shop tab click',
}

export enum TrackWishlistActions {
    AddToWishlist = 'Add to Wishlist',
    RemoveFromWishlist = 'Remove From Wishlist',
}

export enum TrackAppBannerActions {
    SmartBannerImpression = 'Smart Banner Impression',
    SmartBannerClose = 'Smart App Banner Close',
    SmartBannerClick = 'Smart App Banner Click',

    MicroBannerImpression = 'Micro Banner Impression',
    MicroBannerClose = 'Micro App Banner Close',
    MicroBannerClick = 'Micro App Banner Click',

    SmallPushBannerImpression = 'Small Push Banner Impression',
    SmallPushBannerClose = 'Small Push Banner Close Button',
    SmallPushBannerCloseBackground = 'Small Push Banner Close Background',
    SmallPushBannerClick = 'Small Push Banner Click',
}

export enum TrackHeaderBarBannerActions {
    Show = 'Header_bar_banner_show',
    Click = 'Header_bar_banner_click',
    Dismiss = 'Header_bar_banner_close',
}

export enum TrackShopToClubActions {
    OverlayShown = 'Registration overlay shown',
    OverlayDismissed = 'Registration overlay dismissed',
    RegistrationSuccessful = 'Registration successful',
    DoiOverlayShown = 'DOI overlay shown',
    PrivacyPolicyShown = 'Privacy Policy overlay shown',
    PrivacyPolicyAcceptance = 'Acceptance of the Privacy Policy',
    ProductListingBannerImpression = 'Product listing S2C banner impression',
    ProductListingBannerClick = 'Product listing S2C banner Click',
}

export enum TrackLoginAndRegisterActions {
    SuccessfulRegistration = 'Registration',
}

export enum EcommerceActions {
    ProductClick = 'Product Click',
    AddToCart = 'addToCart',
    RemoveFromCart = 'Remove from Cart',
}
export enum HomepageTrackingActions {
    CrossCategoryBubbleClick = 'Cross-category bubbles click',
    BottomCrossCategoryClick = 'Bottom_Cross-category bubbles click',
    SliderArrowComponentClick = 'Homepage arrows clicks',
    PromotionalInfusionClick = 'Promotional infusion',
}

export type TrackingAction =
    | TrackECommerceActions
    | TrackUsersActions
    | TrackFiltersActions
    | TrackPDPActions
    | TrackLooksActions
    | TrackFabricSample
    | TrackPDPVideoActions
    | TrackHeaderActions
    | TrackAppBannerActions
    | TrackHeaderBarBannerActions
    | TrackShopToClubActions
    | TrackLoginAndRegisterActions
    | EcommerceActions
    | HomepageTrackingActions
    | TrackWishlistActions
    | TrackPDPLooksInfusionActions;

export const Actions = {
    SearchLogs: TrackSearchLogsActions,
    Search: TrackSearchActions,
    ECommerce: TrackECommerceActions,
    Users: TrackUsersActions,
    Filters: TrackFiltersActions,
    Header: TrackHeaderActions,
};

// https://developers.google.com/tag-manager/enhanced-ecommerce
export interface OptionalECProductValues {
    category?: string;
    variant?: string;
    position?: number;
    list?: ProductList;
    quantity?: number | string;
}

export interface EcommerceProduct extends OptionalECProductValues {
    name: string;
    id: string;
    price: string;
    brand: string;
}

export interface EcommerceActionField {
    list?: ProductList;
}

export interface EcommerceProductClick {
    click: {
        actionField: EcommerceActionField;
        products: [EcommerceProduct];
    };
}

export interface EcommercePromotionClick {
    promoClick: {
        promotions: Array<Promotion>;
    };
}
export interface EcommercePromotionView {
    promoView: {
        promotions: Array<Promotion>;
    };
}

export interface Promotion {
    id?: string; // Name or ID is required.
    name: string;
    creative?: string;
    position?: string;
    destinationUrl: string;
}

export interface EcommerceProductImpressions {
    currencyCode: string;
    impressions: EcommerceProduct[];
}

export interface EcommerceProductDetailView {
    detail: {
        actionField: EcommerceActionField;
        products: [EcommerceProduct];
    };
}

export interface EcommerceAddToCart {
    currencyCode: Currency;
    add: {
        products: EcommerceProduct[];
    };
}

export interface EcommerceRemoveFromCart {
    currencyCode: string;
    remove: {
        products: [EcommerceProduct];
    };
}

// Todo: Add these variables to the datalayer and add logic to dynamically
// change their values. Also, check for other variables that Alice supports
// that we want to support as well
export interface DatalayerVariableEventOptions {
    value?: string;
    'user-id'?: string;
    'page-number'?: string;
}

export type SpecificGaEvent =
    | typeof PAGEVIEW_EVENT
    | typeof ADD_TO_CART_EVENT
    | typeof REMOVE_FROM_CART_EVENT
    | typeof START_USER_SESSION
    | typeof EC_LP_PRODUCT_CLICK_EVENT
    | typeof EC_LP_PRODUCT_IMPRESSION_EVENT
    | typeof EC_HP_PRODUCT_IMPRESSION_EVENT
    | typeof HEADER_BANNER_SHOW
    | string
    | TrackClubHeaderBarBannerEvents
    | ShopToClubEvent
    | LoginAndRegisterEvent;

export type AdvancedEcommerceOptions =
    | EcommerceProductClick
    | EcommerceProductImpressions
    | EcommerceProductDetailView
    | EcommerceAddToCart
    | EcommerceRemoveFromCart
    | EcommercePromotionClick
    | EcommercePromotionView;

export interface GenericEventOptions extends CommonEventOptions {
    category: string;
}

export interface TrackSearchLogsOptions extends CommonEventOptions {
    action: TrackSearchLogsActions;
}

export interface TrackSearchOptions extends CommonEventOptions {
    action: TrackSearchActions;
}

export interface TrackUsersOptions extends CommonEventOptions {
    action: TrackUsersActions;
}

export interface TrackFiltersOptions extends CommonEventOptions {
    action: TrackFiltersActions;
}

export interface TrackHeaderOptions extends CommonEventOptions {
    action: TrackHeaderActions;
}

export interface TrackECommerceOptions extends CommonEventOptions {
    action: TrackECommerceActions;
}

export interface TrackShopToClubOptions extends CommonEventOptions {
    action: TrackShopToClubActions;
}

export interface TrackLoginAndRegisterOptions extends CommonEventOptions {
    action: TrackLoginAndRegisterActions;
}
export interface TrackAdvancedEcommerceOptions extends DataLayerItem {
    category: typeof E_COMMERCE_CATEGORY;
    ecommerce: AdvancedEcommerceOptions;
}

export type SpecificEventOptions = TrackAdvancedEcommerceOptions | CommonEventOptions;

export type AddImpressedProduct = (product: ProductInterface, options: OptionalECProductValues) => void;

export interface TrackingConfig {
    currency: Currency;
    platform: DataLayerPlatform;
}

export enum TrackClubHeaderBarBannerEvents {
    promotionHeaderBarShown = 'promotion_header_banner_display',
    promotionHeaderBarClicked = 'promotion_header_banner_click',
    promoHeaderBarDismissed = 'promotion_header_banner_dismiss',
}

export enum TrackPDPLoadEvents {
    RatingAndReviewsLoad = 'ratingAndReviewsLoad',
    VideoLoad = 'videoLoad',
    ImageImpressionsLoad = 'imageImpressionsLoad',
}

export enum TrackLLPImpressionEvents {
    NoLooksFound = 'noLooksFound',
    SeeAllLooksButtonImpression = 'seeAllLooksButtonImpression',
    LookPromotionImpression = 'LookPromotionImpression',
}

export enum LOGIN_REGISTER_OVERLAY_EVENTS {
    LOGIN_OVERLAY_CATEGORY = 'Shop Login Overlay',
    REGISTRATION_OVERLAY_CATEGORY = 'Shop Registration Overlay',
    PARTIAL_LOGIN_OVERLAY_CATEGORY = 'Shop Partial Login Overlay',
    LOGIN_OVERLAY_SHOWN = 'Login overlay shown',
    LOGIN_OVERLAY_DISMISSED = 'Login overlay dismissed',
    PARTIAL_LOGIN_OVERLAY_SHOWN = 'Partial login overlay shown',
    PARTIAL_LOGIN_OVERLAY_DISMISSED = 'Partial login overlay dismissed',
    REGISTRATION_OVERLAY_SHOWN = 'Registration overlay shown',
    REGISTRATION_OVERLAY_HIDE = 'Registration overlay dismissed',
    REGISTRATION_SUCCESSFUL = 'Registration successful',
    LOGIN_ACTION = 'Login',
    NEW_REGISTRATION_W_NL = 'New registration with newsletter subscription',
    NEW_REGISTRATION_WO_NL = 'New registration without newsletter subscription',
    LOGIN_PASSED_VIA_REG = 'Login successful',
    LOGIN_FAILED_VIA_REG = 'Correct email but wrong password',
}

export enum UNBLOCK_USER_OVERLAY_EVENTS {
    UNBLOCK_OVERLAY_CATEGORY = 'Shop blocked user overlay',
    UNBLOCK_OVERLAY_IMPRESSION = 'Shop blocked user overlay_Impression',
    UNBLOCK_OVERLAY_CLICK = 'Shop blocked user overlay_Clicks',
}
